import axiosInstance from '../utils/AxiosConfig';

export const getPreparations = async (locationId, page = 1, pageSize = 10, searchTerm = '', options = {}) => {
  const params = new URLSearchParams({
    locationId: locationId.toString(),
    page: page.toString(),
    pageSize: pageSize.toString()
  });
  
  if (searchTerm && typeof searchTerm === 'string' && searchTerm.trim()) {
    params.append('search', searchTerm.trim());
  }
  if (options.sortField) params.append('sortField', options.sortField);
  if (options.sortDirection) params.append('sortDirection', options.sortDirection);
  if (options.filterField) params.append('filterField', options.filterField);
  if (options.filterOperator) params.append('filterOperator', options.filterOperator);
  if (options.filterValue !== undefined && options.filterValue !== null && options.filterValue !== '') {
    params.append('filterValue', options.filterValue.toString());
  }
  
  const response = await axiosInstance.get(`/preparations?${params}`);
  return response.data.data;
};

export const getPreparationById = async (preparationId, locationId) => {
  const response = await axiosInstance.get(`/preparations/${preparationId}`, {
    params: {
      locationId: locationId
    }
  });
  return response.data.data;
};

export const getPreparationsForPackaging = async (locationId) => {
  const response = await axiosInstance.get('/preparations/preparations/multiple_products', {
    params: {
      locationId: locationId
    }
  });
  return response.data.data;
};

export const addPreparation = async (preparation, locationId) => {
  const request = mapFormDataToBackend(preparation, locationId);
  const response = await axiosInstance.post(`/preparations`, request);
  return response.data.data;
};

export const updatePreparation = async (id, preparation, locationId) => {
  const request = mapFormDataToBackend(preparation, locationId);
  const response = await axiosInstance.put(`/preparations/${id}`, request);
  return response.data.data;
};

export const updateStock = async (id, request) => {
  const response = await axiosInstance.put(`/preparations/stock/${id}`, request);
  return response.data.data;
};

export const deletePreparation = async (id) => {
  await axiosInstance.delete(`/preparations/${id}`);
};

const mapFormDataToBackend = (preparation, locationId) => {
  return {
    name: preparation.name,
    preparation_type: preparation.preparationType || 'DEFINED',
    location_id: locationId,
    unit: preparation.unit,
    batch: preparation.batch,
    ...(preparation.costCurrency ? { cost_currency: preparation.costCurrency } : {}),
    stock: preparation.stock,
    suggested_stock: preparation.suggestedStock,
    minimum_stock: preparation.minimumStock,
    category: preparation.categoryId,
    sub_category: preparation.subCategoryId,
    items: preparation.items.map(item => ({
      quantity: Number(item.quantity),
      unit: Number(item.unit),
      reference_type: Number(item.referenceType),
      reference_id: Number(item.referenceId1)
    }))
  };
};
